import CustomersPage from "@/pages/customer/customer-page";
import CreateCustomerPage from "@/pages/customer/create-customer-page";
import CustomerDetailPage from "@/pages/customer/customer-detail-page";
import EditCustomerPage from "@/pages/customer/edit-customer-page";
// import ViewCustomerPage from "@/pages/customer/view-customer";
import { route } from "../utils";
import { RouteType } from "../types";

// Define routes with semantic names - single source of truth
export const customerRoutes: Record<string, RouteType> = {
  list: route("/customers", CustomersPage),
  new: route("/customers/new", CreateCustomerPage),
  edit: route("/customers/:id/edit", EditCustomerPage),
  // view: route("/customers/:id/view", ViewCustomerPage),
  detail: route("/customers/:id", CustomerDetailPage),
};
